import { MediaProportions, MediaType } from '../../../models/graphql';
import { MediaTypePostEditorState } from '../../../models/post-editor';
import { getUploadIdFromFileOrUrl } from '../../../helpers/media';
import { MediaUploadStatus } from '../../../constants/media';

// We can pass single url as a string, a group of urls in one string that are comma delimited.
// or we can pass a string[] with a url string for each
export const getPostEditorMediaTypeFromUrl = (urls: string | string[]): MediaTypePostEditorState[] => {
  // Normalize the input to an array of URLs
  let urlArray: string[];
  if (typeof urls === 'string') {
    // Split the string by commas if it's a single string
    urlArray = urls.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/).map(url => url.trim());
  } else {
    urlArray = urls;
  }

  return urlArray
    .filter(url => url.trim() !== '')
    .map(url => {
      const id = getUploadIdFromFileOrUrl(url);

      return {
        __typename: 'Photo',
        id,
        type: MediaType.PHOTO,
        url,
        thumbnailUrl: url,
        proportions: MediaProportions.SQUARE,
        width: 0,
        height: 0,
        filesize: 0,
        loading: true,
        status: MediaUploadStatus.UPLOADING,
        gif: false,
        length: 0,
        transcoded: false,
        externalUpload: true
      };
    });
};
